import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { PaFiltroComponent } from './pa-filtro/pa-filtro.component';
import { PaListaComponent } from './pa-lista/pa-lista.component';
import { ResultadoPAComponent } from './pa-resultado/resultado-PA.component';
import { PaServiceService } from './pa-service.service';


@NgModule({
  imports: [
    ComumModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    ResultadoPAComponent
  ],
  declarations: [
    ResultadoPAComponent,
    PaFiltroComponent,
    PaListaComponent
  ],
  providers: [
    PaServiceService
  ]
})
export class ResultadoPaModule { }
